/*

Pixel Field Editor - developed by Satori, s.r.o. (c) 2014-2016 - zden@satori.sk
---------------------------------
Legal notice: Source code is for internal purposes only of developing
and integrating Pixel Field Editor to the larger asset of Forms+Surfaces
online services. Any modifications must be discussed with Satori, s.r.o. and no derivates to other projects are allowed without prior written permission from Satori, s.r.o.
---------------------------------
Satori, s.r.o. | Jegeho 21 | 821 08 Bratislava | +421-903-258-862 | www.satori.sk

*/
	function PFAPI_getFilterID(filter)
	{
		switch (filter)
		{
			default:
			case "pixelfield": return FX_PIXFLD; break;
			case "ikat": return FX_IKAT; break;
			case "stripes": return FX_STRIPE; break;
			case "glacier": return FX_GLACIER; break;
			case "crimp": return FX_CRIMP; break;
			case "thatch": return FX_THATCH; break;
			case "cairo": return FX_CAIRO; break;
			case "scatter": return FX_SCATTER; break;
			case "zag": return FX_ZAG; break;
			case "sequence": return FX_SEQUENCE; break;
			case "ice": return FX_ICE; break;
			case "cape": return FX_CAPE; break;
		}
	}

// ______________________________
// action="ListFilters"
// returns filters list
// ______________________________
// action="FilterPreview"
// callback - err, image
// param1 - fx-id
// param2 - rectangle width
// ______________________________
// action="SetImage"
// callback - err, null (no object returned)
// param1 - image
// ______________________________
// action="SetScale"
// callback - err, null (no object returned)
// param1 - width
// param2 - height
// ______________________________
// action="SelectFilter"
// callback - err, null (no object returned)
// param1 - fx-id
// param2 - params object
// ______________________________
// action="PerformFilter"
// callback - err
// ______________________________
// action="PerformFilterSlice"
// callback - err
// param1 = position [x, y]
// param2 = dimension [wid, hei]
// param3 = bleed
// ______________________________
// action="FilterOutputVector"
// callback - err, svg.blob1, svg.blob2, shapes_stats
// note: svg.blob2 is 'null' when used in single layer mode
// ______________________________
// action="FilterOutputVectorMerged"
// callback - err, svg.blob1, null, shapes_stats
// param1 - output mode: 0 - all layers export,1 - Top Color Layer,2 - Bottom Color Layer,3 - Top White Layer,4 - Bottom White Layer
// ______________________________
// action="FilterOutputBinary"
// callback - err, bin.blob1, bin.blob2, shapes_stats
// note: bin.blob2 is 'null' when used in single layer mode
// ______________________________
// action="FilterOutputBinaryMerged"
// callback - err, bin.blob1, null, shapes_stats
// param1 - output mode: 0 - all layers export,1 - Top Color Layer,2 - Bottom Color Layer,3 - Top White Layer,4 - Bottom White Layer
// ______________________________
// action="FilterOutputBitmap"
// callback - err, image
// param1 - type: 0 = 576px, 1 = 1152px, 2 = custom width in pixels; 3 = DPI set in param2
// param2 - width in custom mode (param1 = 2) or DPI (param1 = 3)
// ______________________________
// action="FilterOutputSampleBitmap"
// callback - err, image
// param1 - type: 0 = combined with color fill, 1 = first sample layer isolated, 2 = second sample layer isolated without the color fill
// ______________________________
// action="SetFillAlpha"
// param1 - alpha 0..255
// ______________________________
// action="SetGlassType"
// param1 - 0,1,2 types
// ______________________________

	function PFAPI(action, callback, param1, param2, param3)
	{
		switch (action)
		{
			case "ListFilters":
				var fxlist = new Array();
				fxlist.push({id:"pixelfield", name:"Pixel Field"});
				fxlist.push({id:"ikat", name:"Ikat"});
				fxlist.push({id:"stripes", name:"Stripes"});
				fxlist.push({id:"glacier", name:"Glacier"});
				fxlist.push({id:"crimp", name:"Crimp"});
				fxlist.push({id:"thatch", name:"Thatch"});
				fxlist.push({id:"cairo", name:"Cairo"});
				fxlist.push({id:"scatter", name:"Scatter"});
				fxlist.push({id:"zag", name:"Zag"});
				fxlist.push({id:"sequence", name:"Sequence"});
				fxlist.push({id:"ice", name:"Ice"});
				fxlist.push({id:"cape", name:"Cape"});
				if (callback != null) callback(0);
				return fxlist;
				break;
			case "FilterPreview":
			// param1 - fx-id
			// param2 - rectangle width
				fxlist_generate_preview(PFAPI_getFilterID(param1), param2, callback);
				break;
			case "SetImage":
			// param1 - image object
				set_filter_image(param1, 1, callback);
				break;
			case "SetScale":
			// param1 - width
			// param2 - height
				api_dim_callback = callback;
				dim_api_wid = param1;
				dim_api_hei = param2;
				dim_apply();
				//new_val();
				//dim_new = 1;
				break;
			case "SelectFilter":
			// param1 - fx-id
			// param2 - params object
			// callback return: evaluated parameters object
				fx_selected = PFAPI_getFilterID(param1);
				api_setfx_callback_data = new Array();
				for (var val in param2) UI.setValue(val, param2[val]);
				for (var val in param2) UI.eval_val(val);
				for (var val in param2) api_setfx_callback_data[val] = UI.valuef(val);

				//api_setfx_callback = callback;
				img_fill_color = UI.value('color');
				img_cast_color = UI.value('cast_color');
				colors_update();
				if (callback != null) callback(0);
				break;
			case "PerformFilter":
				api_donefx_callback = callback;

				if (typeof pf_nodejs === "undefined")
					new_val();
				else
				{
					if (pf_nodejs_mth)
						new_threaded_node_frame(0);
					else
						new_node_frame();
				}
				break;
			case "PerformFilterSlice":
				api_donefx_callback = callback;

				if (!(typeof pf_nodejs === "undefined"))
				{
					if (pf_nodejs_mth)
						new_threaded_node_frame(1, param1, param2, param3);
					else
						new_node_frame();
				}
				break;
			case "FilterOutputBinary":
			// no params used
				save_bin(null, 1, callback, param1);
				break;
			case "FilterOutputBinaryMerged":
			// no params used
				save_bin(null, 2, callback, param1);
				break;
			case "FilterOutputVector":
			// no params used
				save_svg(null, 1, callback, param1);
				break;
			case "FilterOutputVectorMerged":
			// no params used
				save_svg(null, 2, callback, param1);
				break;
			case "FilterOutputBitmap":
			// param1 - type: 0 = 576px, 1 = 1152px, 2 = custom width; 3 = custom DPI
			// param2 - width in custom mode (param1 = 2) or DPI (param1 = 3)
				api_bitmap_callback = callback;
				if (typeof pf_nodejs === "undefined")
					save_layers_start(param1, typeof param2 === "undefined" ? 0 : param2);
				else
					save_node_layers(param1, api_slice, typeof param2 === "undefined" ? 0 : param2);
				break;
			case "FilterOutputSampleBitmap":
			// param1 - type: 0 = combined with color fill, 1 = first sample layer isolated, 2 = second sample layer isolated without the color fill
				api_bitmap_callback = callback;
				if (!(typeof pf_nodejs === "undefined"))
					save_node_layers(param1, 1);
				break;
			case "SelectCanvases":
			// param1 - list of canvases (4 objects) 0/1 - full; 2/3 - detail
			// param2 - list of contexes (4 objects) 0/1 - full; 2/3 - detail
				for (var a = 0; a < 4; a++)
				{
					api_canvas[a] = param1[a];
					api_context[a] = param2[a];
				}

				if (callback != null) callback(0);
				break;
			case "SelectDetail":
			// param1 - [ x, y ] position in the image
			// param2 - [ w, h ] dimensions of detail view
				api_detail_data.pos = param1;
				api_detail_data.dim = param2;
				api_detail_data.bleed = 0;
				if (typeof pf_nodejs === "undefined")
				{
					api_detail_request = 1;
					api_detail_callback = callback;
				}
				break;
			case "SetLayersMode":
			// param1 - 2 = standard two layers, 1 - single layer
				api_layers = param1;
				if (api_layers < 1) api_layers = 1;
				if (api_layers > 2) api_layers = 2;
				break;
			case "SetFillAlpha":
				api_fill_alpha = Math.min(Math.max(param1, 0), 255);
				api_fill_alpha /= 255;
				break;
			case "SetGlassType":
				glass_type = param1;
				break;

		}
		return 0;
	}